module.exports = __webpack_public_path__ + "img/yoga.3eff97a5.svg";